export const METHOD_API_DOWNLOAD_CONFIGURATION = "1346c8a9-d04e-4ba2-b4ec-0142e706cfa6";
export const METHOD_API_CONFIGURATION = "c56eeb8a-07fc-4d5f-9a6d-e23608179f38";
export const METHOD_EMAIL_CONFIGURATION = "25e002d8-c055-4d57-8be1-cba76eb56a21";